import { render, staticRenderFns } from "./gerallogs.vue?vue&type=template&id=489d915d&"
import script from "./gerallogs.vue?vue&type=script&lang=js&"
export * from "./gerallogs.vue?vue&type=script&lang=js&"
import style0 from "./gerallogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports